const programmeOptions = [
    { id: 7, full_name: 'Global Volunteer' },
    { id: 8, full_name: 'Global Talent' },
    { id: 9, full_name: 'Global Teacher' }
  ];
  
  export default programmeOptions;